/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Tab_Has_ErrorsInputs */

const cs_validation_tab_has_errors = /** @type {(inputs: Validation_Tab_Has_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obsahuje chyby`)
};

const en_validation_tab_has_errors = /** @type {(inputs: Validation_Tab_Has_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contains errors`)
};

/**
* | output |
* | --- |
* | "Contains errors" |
*
* @param {Validation_Tab_Has_ErrorsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const validation_tab_has_errors = /** @type {((inputs?: Validation_Tab_Has_ErrorsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Tab_Has_ErrorsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validation_tab_has_errors(inputs)
	return cs_validation_tab_has_errors(inputs)
});